module.exports = __webpack_public_path__ + "static/img/maidisen_icon.df6fcad9.png";